var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-text-field", {
    ref: "control",
    staticClass: "dynamic-input-control",
    class: {
      "dynamic-input-control": true,
      "hide-error-icon": true,
      dense: _vm.dense,
      "no-label": true,
      "text-right": _vm.textRight,
      "hide-label": _vm.hideLabel
    },
    attrs: {
      suffix: "%",
      dense: _vm.dense,
      "hide-details": "",
      readonly: _vm.readonly,
      outlined: "",
      disabled: _vm.disabled,
      label: "Zisk",
      "error-messages": _vm.error
    },
    on: {
      focusout: _vm.lostFocus,
      change: function($event) {
        return _vm.setDirty(true)
      }
    },
    model: {
      value: _vm.stringValue,
      callback: function($$v) {
        _vm.stringValue = $$v
      },
      expression: "stringValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }